import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
var Seguimiento_exp_Service = /** @class */ (function () {
    function Seguimiento_exp_Service(_http) {
        this._http = _http;
        this.url = GLOBAL.url;
    }
    Seguimiento_exp_Service.prototype.getSolicitudes = function (rut) {
        var params = {
            rut: rut
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'seguimiento_expediente', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    /* getRut(rut, departamento){
         let params = {
             rut: rut,
             departamento:departamento
            
         };
 
         let headers = new Headers({
             'Content-type': 'application/json',
             'Authorization': sessionStorage.getItem("token-domCloud")
         });
 
         return this._http.post(this.url+'seguimiento_expediente', params, {headers: headers})
         .pipe(map(res => res.json()));
     }*/
    Seguimiento_exp_Service.prototype.getExp = function (rut, numero, departamento) {
        var params = {
            rut: rut,
            numero: numero,
            departamento: departamento
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'seguimiento_solicitud', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    Seguimiento_exp_Service.prototype.getActa = function (exp) {
        var params = {
            exp: exp
        };
        var headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });
        return this._http.post(this.url + 'acta_expediente', params, { headers: headers })
            .pipe(map(function (res) { return res.json(); }));
    };
    return Seguimiento_exp_Service;
}());
export { Seguimiento_exp_Service };
